import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "./components/navbar";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import StoneTypes from "./pages/StoneTypes";
import Cart from "./pages/Cart";
import "./i18n";
import Footer from "./components/Footer";
import ProjectDetails from "./pages/ProjectDetails";
import StoneDetail from "./pages/StoneDetail";
import OrderForm from "./pages/OrderForm";
import AboutUs from "./pages/AboutUs";
import { CartProvider } from "./context/CartContext";
import { AppLanguage } from "./context/ApplicationLanguage";

function App() {
  const { i18n } = useTranslation();
  const appLang = useContext(AppLanguage);

  return (
    <div dir={appLang.language === "ar" ? "rtl" : "ltr"}>
      <CartProvider>
        <Router>
          <>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/stone-types" element={<StoneTypes />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/AboutUs" element={<AboutUs />} />
              <Route path="/project/:id" element={<ProjectDetails />} />
              <Route path="/stone/:id" element={<StoneDetail />} />
              <Route path="/orderform" element={<OrderForm />} />
            </Routes>
            <Footer />
          </>
        </Router>
      </CartProvider>
    </div>
  );
}

export default App;
